export default "__VITE_ASSET__0ba7ca29__"